import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=56829512&scoped=true"
import script from "./LanguageToggle.vue?vue&type=script&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&lang=js"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=56829512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56829512",
  null
  
)

export default component.exports